import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { QConfigStatus } from '@exam-management/graphql';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QConfigPublishErrorsAlert } from '@exam-management/qconfig-detail';
import {
  ExamOverviewSection,
  ExamTimingSection,
  PassingCriteriaSection,
  QConfigSettingsFormProvider,
  QuestionRandomizationSection,
} from '@exam-management/qconfig-settings';
import { Divider, Flex, FormButton, PaperSection } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

export default function QConfigSettingsPage() {
  const hasPermissionUpdate = useHasPermission(APP_PERMISSIONS.EXAM.QCONFIG.UPDATE);
  const { qConfigData } = useQConfig();
  const { status } = qConfigData;

  const isDraftQConfig = status === QConfigStatus.Draft;

  return (
    <QConfigSettingsFormProvider>
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
      >
        <QConfigPublishErrorsAlert />
        <PaperSection title='QConfig Settings'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(8),
              p: theme.spacing(6),
            })}
          >
            <ExamOverviewSection />
            <Divider />
            <PassingCriteriaSection disabled={!hasPermissionUpdate} />
            <Divider />
            <ExamTimingSection disabled={!hasPermissionUpdate} />
            <Divider />
            <QuestionRandomizationSection disabled={!hasPermissionUpdate} />
          </Flex>
        </PaperSection>
        {isDraftQConfig && hasPermissionUpdate ? (
          <Flex sx={{ justifyContent: 'center' }}>
            <FormButton label='Save' variant='outlined' />
          </Flex>
        ) : null}
      </Flex>
    </QConfigSettingsFormProvider>
  );
}
